module.exports = __webpack_public_path__ + "img/vbyvisa_blu.f3e00c51.png";